import React, {FC, useState} from 'react';

import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../../../../../../../src/services/tracking';
import {Trans} from '../../../../../../../../../shared/helpers/src/internationalization/react';
import {AsyncHandlerOf, Handler} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {DeleteCardGroupConfirmationDialog} from '../../../../dialogs/deleteCardGroupConfirmationDialog';

/*
 * Props.
 */

interface CardGroupsTableMultiDeleteActionProps {
  cardGroupIds: ReadonlyArray<number>;
  onDeleteCardGroupsAsync: AsyncHandlerOf<ReadonlyArray<number>>;
  onForceRefresh: Handler;
}

/*
 * Component.
 */

export const CardGroupsTableMultiDeleteAction: FC<CardGroupsTableMultiDeleteActionProps> = (props) => {
  const {cardGroupIds, onDeleteCardGroupsAsync, onForceRefresh} = props;
  const [isShowingDeleteDialog, setIsShowingDeleteDialog] = useState(false);

  const onDeleteHandler = async () => {
    setIsShowingDeleteDialog(false);
    try {
      await onDeleteCardGroupsAsync(cardGroupIds);
      trackInterfaceEvent(InterfaceEventsEnum.CONTACTS_MANAGER_CARD_GROUP_DELETE, {
        namespace: 'multiple',
        num_deleted: cardGroupIds.length,
      });
      onForceRefresh();
    } catch {
      // TODO: Show a failed banner.
    }
  };

  return (
    <>
      <Button
        variant={ButtonVariantsEnum.SECONDARY_DANGER}
        hasHover={isShowingDeleteDialog}
        onClick={() => setIsShowingDeleteDialog(true)}
      >
        <Trans id="contact-manager-card-groups-table-multi-select-actions-delete">Delete</Trans>
      </Button>
      {isShowingDeleteDialog && (
        <DeleteCardGroupConfirmationDialog
          numberToDelete={cardGroupIds.length}
          onClose={() => setIsShowingDeleteDialog(false)}
          onDelete={onDeleteHandler}
        />
      )}
    </>
  );
};
